// inbox/PhoneText.jsx — 5A-fix3 (البند 3) · عرض رقم هاتف معزول الاتجاه.
// أي رقم هاتف في الصندوق يمر من هنا: dir="ltr" + unicode-bidi: isolate
// يمنعان انعكاس علامة «+» بصرياً داخل سياق عربي محيط (rtl)، بخلاف
// خاصية CSS direction وحدها التي لا تكفي لعزل الاتجاه بصرياً.
import React from "react";
import { displayPhone } from "./theme";

export const PhoneText = ({ value, style, testId, className }) => (
  <span dir="ltr" data-testid={testId} className={className}
    style={{ unicodeBidi: "isolate", direction: "ltr", ...style }}>
    {displayPhone(value)}
  </span>
);
